function DateRange({ onChange, onApply }) {
  const onSubmit = (e) => {
    e.preventDefault();
    onApply();
  };

  return (
    <div>
      <form
        onSubmit={onSubmit}
        className="d-flex gap-3 align-items-end mb-2"
        style={{ maxWidth: 600 }}
      >
        <div className="col-12 col-md-5">
          <label className="form-label fw-bold">Start Date:</label>
          <input
            type="date"
            className="form-control"
            required
            onChange={(e) => onChange(e.target.value, "startDate")}
          />
        </div>
        <div className="col-auto d-flex justify-content-center align-items-center">
          <i className="bi bi-arrow-right fs-4 text-muted"></i>
        </div>
        <div className="col-12 col-md-5">
          <label className="form-label fw-bold">End Date:</label>
          <input
            type="date"
            className="form-control"
            required
            onChange={(e) => onChange(e.target.value, "endDate")}
          />
        </div>
        <div className="col-12 d-flex">
          <button
            type="submit"
            className="btn fw-bold text-white px-4 py-2 border"
            style={{
              backgroundColor: "#e09552",
              borderRadius: "6px",
              minWidth: "150px",
            }}
          >
            Apply
          </button>
        </div>
      </form>
    </div>
  );
}

export default DateRange;
